import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { notification, logError } from 'redux/modules/app'
import NotificationSystem from 'react-notification-system'
import styles from './notification.styl'
import NotificationContent from './NotificationContent'

@injectIntl
@connect(
  state => ({
    app: state.app
  }),
  { notification, logError }
)
class Notification extends Component {
  static propTypes = {
    notification: PropTypes.func,
    logError: PropTypes.func,
    app: PropTypes.object,
    intl: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = {}
    this.notify = null
  }

  componentDidMount() {
    this.notify = this.refs.notificationSystem
  }

  componentWillReceiveProps(nextProps) {
    const { intl, app } = this.props
    const { message, level, active, options } = nextProps.app.notification
    const title = get(options, 'title')
    const buttonLabel = get(options, 'buttonLabel')
    const callback = get(options, 'callback')
    const action = (buttonLabel || callback)
      && {
        label: buttonLabel,
        callback
      }

    // handle catch errors
    if (
      !get(app, 'error.body.errorCode') &&
      get(app, 'error.body.errorCode') !==
        get(nextProps.app, 'error.body.errorCode')
    ) {
      this.handleErrorMessage(nextProps.app.error)
    }

    // return if notification has not been set as active
    if (!active) {
      return
    }

    this.notify.addNotification({
      title,
      children: <NotificationContent message={options.intlKey
        ? intl.formatMessage({ id: options.intlKey, defaultMessage: message })
        : message} showCopyLink={(options.status || level) === 'error'} />,
      level: options.status || level,
      position: 'bc',
      autoDismiss: 5,
      onRemove: this.handleRemove(),
      action
    })
  }

  handleRemove() {
    this.props.notification('', '', false)
    this.props.logError({})
  }

  handleErrorMessage = (err = {}) => {
    console.log('err', err)

    const isApiV2 = !!get(err, 'body.id')

    const message = isApiV2
      ? get(err, 'body.message')
      : get(err, 'body.userMessage') || get(err, 'body.developerMessage') ||  'Something went wrong'

    switch (get(err, 'body.errorCode')) {
      case 'UNAUTHORIZED':
        if (get(err, 'options.authCode')) {
          this.props.notification('Authorization code is not longer valid', {
            status: 'error',
            intlKey: 'notifications.authorization_code_is_not_valid'
          })
        } else {
          this.props.notification(
            message,
            {
              status: 'error'
            }
          )
        }
        break
      case 'AUTH_CODE_NOT_FOUND':
        this.props.notification('Authorization code is not longer valid', {
          status: 'error',
          intlKey: 'notifications.authorization_code_is_not_valid'
        })

        break
      case 'AUTH_CODE_EXPIRATED':
        this.props.notification('Authorization code has expired', {
          status: 'error',
          intlKey: 'notifications.authorization_code_has_expired'
        })

        break

      default:
        this.props.notification(
          message,
          {
            status: 'error'
          }
        )
    }
  }

  render() {
    return (
      <NotificationSystem
        className={styles.reactNotificiation}
        ref="notificationSystem"
        style={false}
      />
    )
  }
}

export default Notification
